var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"max-width":"full","outlined":""}},[_c('v-card-text',{staticClass:"d-flex justify-center"},[_c('p',{staticClass:"text-h4"},[_vm._v("404")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }